import Skeleton from '../skeleton/Skeleton';
import { StyledTeam } from './Team.styles';

/** The whole page's shape, shown until the members and pending invites have both arrived. */
const TeamSkeleton = () => (
  <StyledTeam aria-busy="true">
    <div className="team-subbar">
      <div className="team-subbar-inner">
        <Skeleton width="32px" height="32px" radius="10px" />
        <Skeleton width="140px" height="14px" radius="6px" />
      </div>
    </div>

    <main className="team-main">
      <div className="team-head">
        <Skeleton width="280px" height="30px" radius="8px" resp />
        <Skeleton width="420px" height="14px" radius="6px" margin="10px 0 0" resp />
      </div>

      <section className="team-section">
        <div className="section-head">
          <div>
            <Skeleton width="120px" height="18px" radius="6px" />
            <Skeleton width="260px" height="13px" radius="6px" margin="8px 0 0" resp />
          </div>
          <Skeleton width="150px" height="40px" radius="14px" />
        </div>
        <div className="ws-grid">
          {[0, 1].map(key => (
            <div key={key} className="ws-card">
              <div className="ws-identity">
                <Skeleton width="40px" height="40px" radius="14px" />
                <div className="ws-text">
                  <Skeleton width="140px" height="15px" radius="6px" />
                  <Skeleton width="100px" height="12px" radius="6px" margin="6px 0 0" />
                </div>
              </div>
              <Skeleton width="64px" height="22px" radius="999px" />
            </div>
          ))}
        </div>
      </section>

      <section className="team-section">
        <div className="section-head">
          <div>
            <Skeleton width="220px" height="18px" radius="6px" resp />
            <Skeleton width="320px" height="13px" radius="6px" margin="8px 0 0" resp />
          </div>
        </div>
        <Skeleton width="100%" height="52px" radius="18px" />
      </section>

      <section className="team-section">
        <div className="section-head-row">
          <Skeleton width="130px" height="18px" radius="6px" />
        </div>
        <div className="team-list">
          {[0, 1, 2].map(key => (
            <div className="team-row" key={key}>
              <Skeleton width="40px" height="40px" circle />
              <div className="row-identity">
                <Skeleton width="140px" height="15px" radius="6px" />
                <Skeleton width="200px" height="13px" radius="6px" margin="6px 0 0" />
              </div>
              <Skeleton width="96px" height="36px" radius="14px" />
            </div>
          ))}
        </div>
      </section>
    </main>
  </StyledTeam>
);

export default TeamSkeleton;
